<template>
     <el-dialog
     title="创建新规则"
     :visible.sync="dialogVisible"
     width="450px"
     top="10vh"
    :show-close="true"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @close="closeDialog"
    >
       <div class="panel">
           <el-form ref="fieldForm" :model="form" :rules="formRules" label-width="85px">
                <el-row :gutter="5">
                    <el-col :span="24">
                        <el-form-item label="校验规则" prop="calFormat">
                            <div>

                                <el-button type="primary" size="small" @click="addRule" v-if="form.calFormat == ''"><i class="el-icon-circle-plus-outline"></i>新增</el-button>
                                <el-button type="primary" size="small" @click="editRule" v-if="form.calFormat != ''"><i class="el-icon-edit"></i>修改</el-button>
                                <br />
                                <el-tag  type="info" v-if="form.calFormat != ''">{{form.calFormat}}</el-tag>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="错误提示" prop="name">
                            <el-input v-model="form.name" size="small" type="text" placeholder="请输入错误提示"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="状态" prop="orderSatus">
                             <el-select
                                v-model="form.orderSatus"
                                filterable
                                placeholder="请选择"
                                style="width:100%;"
                            >
                                <el-option
                                v-for="item in orderStatusList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                </el-row>
           </el-form>


       </div>
       <div class="panel-bottom">
            <el-button size="small" type="default"  @click="closeDialog">取消</el-button>
            <el-button size="small" type="primary"  @click="handleSave">保存</el-button>
        </div>

         <el-dialog
            title="编辑计算公式"
            :visible.sync="dialogVisible1"
            width="550px"
            top="10vh"
            :show-close="true"
            :modal-append-to-body="true"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            @close="closeDialog1"
        >
            <div>
                <el-input
                    type="textarea"
                    placeholder="请输入内容"
                    v-model="calFormat"
                    maxlength="2000"
                    :autosize="{ minRows: 10, maxRows: 10}"
                    show-word-limit
                ></el-input>
            </div>
            <div style="font-size:12px;line-height:25px;">
                <span>支持英文模式下符号:</span><br />
                <span>运算符号：加 (+)、减 (-)、乘 (*)、除 (/)</span><br />
                <span>判断符号：等于 (==)、不等于 (!=)、大于 (&gt;)、小于 (&lt;)、大于等于 (&gt;=)、小于等于 (&lt;=)</span><br />
                <span>条件符号：且 (&amp;&amp;)、或（||）</span><br />
                <span>语法符号：小括号 (())、大括号 ({})、dollar符 ($)、逗号 (,)、分号 (;)、双引号 (")、单引号 (')</span>
            </div>

            <div class="panel-bottom">
                <el-button size="small" type="default"  @click="closeDialog1">取消</el-button>
                <el-button size="small" type="primary"  @click="handleSave1">确定</el-button>
            </div>
        </el-dialog>

    </el-dialog>
</template>
<script>
export default {
    name:'addRules',
    props:{
        diaVisible:{
            type:Boolean,
            default:false,
        },
        fieldData:{
            type:Object,
            default:function(){
                return {};
            }
        }
    },
    watch:{
        diaVisible(newVal,oldVal){
            if(newVal){
                this.dialogVisible = newVal;
            }
        },
        fieldData(newVal,oldVal){
            if(newVal){
                this.form = JSON.parse(JSON.stringify(newVal));
            }
        }
    },
    data(){
        return{
            dialogVisible: false,
            form:{
              producerId:'',
              orderSatus:'',
              calFormat:'',
            },
            formRules:{
              producerId:[
                    {
                        required: true,
                        message: "请输入字段名称",
                        trigger: "blur",
                    }

                ],
                orderSatus:[
                    {
                        required: true,
                        message: "请选择字段类型",
                        trigger: "blur",
                    }
                ],
                calFormat:[
                    {
                        required: true,
                        message: "请填写校验规则",
                        trigger: "blur",
                    }
                ]
            },
            orderStatusList: [
                {
                    label: "未启用",
                    value: "0"
                },
                {
                    label: "启用",
                    value: "1"
                },
            ],


            dialogVisible1:false,
            calFormat:'',

        }
    },
    created(){

    },
    methods:{
        handleSave(){
            this.$refs["fieldForm"].validate((valid) => {

                if (valid) {
                    this.dialogVisible = false;
                    this.$emit('save',this.form);
                }
            })

        },

        closeDialog(){
            setTimeout(() => {
                this.dialogVisible = false;
                this.$parent.createProductPanVisible = false;
            }, 100);
        },

        closeDialog1(){
            this.dialogVisible1 = false;
        },
        handleSave1(){
            this.form.calFormat = this.calFormat;
            this.dialogVisible1 = false;
        },
        addRule(){
            this.dialogVisible1 = true;
        },
        editRule(){
            this.dialogVisible1 = true;
        }

    }

}
</script>
<style scoped>
    .panel{
        /* width: 100%; */
        height: 230x;
        overflow-y: auto;
        overflow-x: hidden;
        /* padding: 0px 50px; */
    }

    .panel-bottom{
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding-top: 20px;
        text-align: center;
    }
    .panel-bottom el-button{
        margin: 10px 0 0 10px;
    }


</style>



// WEBPACK FOOTER //
// src/views/customSetting/order/addRules.vue